/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { I18nModule, UrlModule } from '@lm-nx-frontend/lm-inf-core';
import { PopoverModule } from '@lm-nx-frontend/lm-inf-ui';
import { CostCenterDetailsCellComponent } from './cost-center-details-cell.component';

@NgModule({
  imports: [CommonModule, PopoverModule, RouterModule, I18nModule, UrlModule],
  declarations: [CostCenterDetailsCellComponent],
  exports: [CostCenterDetailsCellComponent],
})
export class CostCenterDetailsCellModule {}
